// Third-party imports
import Shopify from 'shopify_api';

// Local imports
import * as config from '../config.js';
import * as event_mod from '../event.js';
import { init_datalayer, push_utag_data } from '../init.js';
import { PAGE_VARS } from '../../page/vars.js';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'datalayer_spsh';

// Re-exports
export let global_vars = {};

export const CHECKOUT = {
    product_id: [],
    product_name: [],
    product_brand: [],
    product_variant: [],
    product_category: [],
    product_price: [],
    product_age: [],
    product_gender: [],
    product_country: [],
    product_list_name: [],
    product_list_position: [],
    product_quantity: [],
    product_sku: [],
    product_url: [],
    product_type: [],
    product_set: [],

    payment_method: '',
};

// ===========================================================================
// Data layer handlers
// ===========================================================================

// TODO: should this be enabled or removed?
// function onchange_page(global, utag_data, url, title) {
//     global.document.addEventListener('beforeunload', () => {
//         controller(global, utag_data, url, title);
//     });
// }

// global arg is expected to be the window object when run in a browser
function controller(global, utag_data, url, title) {
    let lang = global.document.querySelector('body').dataset.lang;
    update_data(global, utag_data, url, title, lang);
    let step = Shopify.Checkout.step;
    switch (step) {
        case 'payment_method':
            payment_method_handler(global, utag_data, title);
            break;
        case 'contact_information':
            contact_info_handler(global, utag_data, title);
            break;
        case 'processing':
            processing_handler(global, utag_data, title);
            break;
        case 'thank_you':
            thank_you_handler(global, utag_data, title, lang);
            break;
    }
    push_utag_data(utag_data);

    event_mod.dispatch(global, event_mod.EventKind.DOMReady);
}

// global arg is expected to be the window object when run in a browser
function payment_method_handler(global, utag_data, title) {
    utag_data['page_name'] = title;
    utag_data['page_type'] = 'PaymentPage';
    utag_data['device_type'] = config.DEVICE.device;

    // NEW
    utag_data['product_id'] = CHECKOUT.product_id;
    utag_data['product_name'] = CHECKOUT.product_name;
    utag_data['product_brand'] = CHECKOUT.product_brand;
    utag_data['product_variant'] = CHECKOUT.product_variant;
    utag_data['product_category'] = CHECKOUT.product_category;
    utag_data['product_price'] = CHECKOUT.product_price;
    utag_data['product_age'] = CHECKOUT.product_age;
    utag_data['product_gender'] = CHECKOUT.product_gender;
    utag_data['product_country'] = CHECKOUT.product_country;
    utag_data['product_set'] = CHECKOUT.product_set;
    utag_data['enh_checkout_step'] = 3;
    utag_data['enh_action'] = PAGE_VARS.action;
}

// global arg is expected to be the window object when run in a browser
function contact_info_handler(global, utag_data, title) {
    // Carried over from old code
    utag_data['page_name'] = title;
    utag_data['page_type'] = 'InfoSummary';
    utag_data['device_type'] = config.DEVICE.device;

    // NEW
    utag_data['product_id'] = CHECKOUT.product_id;
    utag_data['product_name'] = CHECKOUT.product_name;
    utag_data['product_brand'] = CHECKOUT.product_brand;
    utag_data['product_variant'] = CHECKOUT.product_variant;
    utag_data['product_category'] = CHECKOUT.product_category;
    utag_data['product_price'] = CHECKOUT.product_price;
    utag_data['product_age'] = CHECKOUT.product_age;
    utag_data['product_gender'] = CHECKOUT.product_gender;
    utag_data['product_country'] = CHECKOUT.product_country;
    utag_data['product_set'] = CHECKOUT.product_set;
    utag_data['enh_checkout_step'] = 2;
    utag_data['enh_action'] = PAGE_VARS.action;
}

// global arg is expected to be the window object when run in a browser
function processing_handler(global, utag_data, title) {
    utag_data['page_name'] = title;
    utag_data['page_type'] = 'InfoSummary';
    utag_data['device_type'] = config.DEVICE.device;
    utag_data['event_type'] = 'processing';
}

function cart_attrs(utag_data) {
    let order_data = Shopify.checkout;
    utag_data['customer_email'] = order_data.email;

    // cart attributes
    for (let n in order_data.billing_address) {
        switch (n.toLowerCase()) {
            case 'city':
                utag_data['customer_city'] = order_data.billing_address[n];
                break;
            case 'first_name':
                utag_data['customer_name'] =
                    order_data.billing_address[n] +
                    ' ' +
                    order_data.billing_address['last_name'];
                break;
            case 'zip':
                utag_data['customer_postal_code'] =
                    order_data.billing_address[n];
                break;
            case 'province':
                utag_data['customer_state'] = order_data.billing_address[n];
                break;
        }
    }
}

// global arg is expected to be the window object when run in a browser
function init_utag(global, utag_data, title, lang) {
    let order_data = Shopify.checkout;

    // Carried over from old
    utag_data['page_type'] = 'ThankYouPage';
    utag_data['page_name'] = title;
    utag_data['order_id'] = order_data.order_id;
    utag_data['order_total'] = order_data.total_price;
    utag_data['order_merchandise_total'] = order_data.total_price;
    utag_data['order_ship_type'] = 'none';
    utag_data['order_discount'] = order_data.discount;
    utag_data['order_ship_amt'] = '0';
    utag_data['order_tax'] = order_data.total_tax;
    utag_data['order_subtotal'] = order_data.subtotal_price;
    utag_data['order_payment_type'] = CHECKOUT.payment_method || 'unknown';
    utag_data['device_type'] = config.DEVICE.device;
    utag_data['page_language'] = `${lang}-CA`;

    // NEW
    utag_data['product_id'] = CHECKOUT.product_id;
    utag_data['product_name'] = CHECKOUT.product_name;
    utag_data['product_brand'] = CHECKOUT.product_brand;
    utag_data['product_variant'] = CHECKOUT.product_variant;
    utag_data['product_category'] = CHECKOUT.product_category;
    utag_data['product_price'] = CHECKOUT.product_price;
    utag_data['product_age'] = CHECKOUT.product_age;
    utag_data['product_gender'] = CHECKOUT.product_gender;
    utag_data['product_country'] = CHECKOUT.product_country;
    utag_data['product_set'] = CHECKOUT.product_set;
    utag_data['enh_action'] = 'purchase';

    // Requires Clarification
    // Clarify that this is right
    utag_data['enh_currency_code'] = ' CAD ';
    utag_data['order_promo_code'] = ' ORDER_PROMO_CODE ';
    utag_data['order_gift_card_code'] = ' order_gift_card_code ';
}

// global arg is expected to be the window object when run in a browser
function thank_you_handler(global, utag_data, title, lang) {
    cart_attrs(utag_data);
    init_utag(global, utag_data, title, lang);
}

// ===========================================================================
// Data layer
// ===========================================================================

function update_data(global, utag_data, url, title, lang) {
    utag_data['product_age'] = CHECKOUT.product_age;
    utag_data['product_brand'] = CHECKOUT.product_brand;
    utag_data['product_category'] = CHECKOUT.product_category;
    utag_data['product_country'] = CHECKOUT.product_country;
    utag_data['product_gender'] = CHECKOUT.product_gender;
    utag_data['product_id'] = CHECKOUT.product_id;
    utag_data['product_list'] = CHECKOUT.product_list_name;
    utag_data['product_position'] = CHECKOUT.product_list_position;
    utag_data['product_name'] = CHECKOUT.product_name;
    utag_data['product_type'] = CHECKOUT.product_type;
    utag_data['product_price'] = CHECKOUT.product_price;
    utag_data['product_quantity'] = CHECKOUT.product_quantity;
    utag_data['product_sku'] = CHECKOUT.product_sku;
    utag_data['product_url'] = CHECKOUT.product_url;
    utag_data['product_variant'] = CHECKOUT.product_variant;

    // Language eg en, fr, zh, etc
    utag_data['language'] = `${lang}-CA`;
    utag_data['page_name'] = title;

    // If impression_name is undefined, then triggering the tealium event will
    // fail
    utag_data['impression_name'] = '';
}

// TODO: This is tied to what will be done with onchange_page
// function init_handlers(global, data) {
//     onchange_page(
//         global,
//         data.utag_data,
//         global.location.href,
//         global.document.title
//     );
// }

export function initialize(global) {
    init_datalayer(global, () => {}, controller);
}

// ===========================================================================
//
// ===========================================================================
